const siteConfig = {
  // Site Information
  siteName: "XQ Sadness",
  siteTitle: "xqsadness | iOS Developer & Creative Development",
  siteDescription:
    "Professional portfolio of xqsadness showcasing iOS app development and creative web design work.",
  siteKeywords: "xqsadness, iOS Developer, xqsadness developer, App Developer, Mobile Developer, creative web design, portfolio, XQ Sadness",
  recaptchaSiteKey: "6LfSMAArAAAAAP2u_vM-WBSFilWDqD5Z147dljMB",

  // Author Information
  author: {
    name: "XQSadness",
    role: "Creative Developer",
    github: "https://github.com/xqsadness",
    email: "xuanquy2433@gmail.com",
    emailTo: "undefined.anonymou@gmail.com"
  },

  // Navigation Links
  navLinks: [
    { name: "Home", path: "#home" },
    { name: "Skills", path: "#skills" },
    { name: "Projects", path: "#projects" },
    { name: "About", path: "#about" },
  ],

  // Social Media Links
  socialLinks: {
    github: "https://github.com/xqsadness",
    linkedin: "#",
    instagram: "#",
    facebook: "#",
  },

  // Theme Colors
  colors: {
    primary: {
      start: "#AA367C",
      end: "#4A2FBD",
    },
    gradient: "linear-gradient(90.21deg, #AA367C -5.91%, #4A2FBD 111.58%)",
    background: "#121212",
    text: "#ffffff",
  },

  //Skills
  skills: [
    {
      name: "Swift / SwiftUI",
      percentage: 55,
    },
    {
      name: "SwiftData / Core Data",
      percentage: 55,
    },
    {
      name: "iOS Development",
      percentage: 55,
    },
    {
      name: "Firebase (Auth, Firestore, Storage)",
      percentage: 55,
    },
    {
      name: "UIKit / Combine",
      percentage: 55,
    },
    {
      name: "Java / Spring Boot",
      percentage: 55,
    },
    {
      name: "JavaScript",
      percentage: 55,
    },
    {
      name: "React.js",
      percentage: 55,
    },
    {
      name: "SQL Server",
      percentage: 55,
    },
    {
      name: "Git (CLI)",
      percentage: 55,
    },
  ],

  //Experience
  experiences: [
    {
      period: "02/2023 – Present",
      role: "iOS Developer",
      company: "iOS Developer",
      type: "Full-time",
      achievements: [
        "Developing iOS applications using Swift and SwiftUI",
        "Working with iOS frameworks and technologies",
      ],
    },
    {
      period: "08/2020 – 01/2023",
      role: "Software Engineering Student",
      company: "FPT University",
      type: "Education",
      achievements: [
        "Studied Software Engineering with focus on Web Development",
        "Learned various web technologies including Java basic to advanced, JavaScript, React.js, and Spring Boot",
        "Developed multiple web applications using modern frameworks and tools",
      ],
    },
  ],

  //Tools
  tools: [
    {
      name: "Xcode",
      description: "iOS & macOS development environment",
      icon: "https://developer.apple.com/assets/elements/icons/xcode-12/xcode-12-96x96_2x.png",
      link: "https://developer.apple.com/xcode/",
    },
    {
      name: "Visual Studio Code",
      description: "Primary code editor for web development",
      icon: "https://cdn.worldvectorlogo.com/logos/visual-studio-code-1.svg",
      link: "https://code.visualstudio.com/",
    },
    {
      name: "Cursor",
      description: "AI-powered code editor",
      icon: "https://cursor.sh/apple-touch-icon.png",
      link: "https://cursor.sh/",
    },
    {
      name: "Git",
      description: "Version control system",
      icon: "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
      link: "https://git-scm.com/",
    },
    {
      name: "Firebase",
      description: "Backend & hosting platform",
      icon: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      link: "https://firebase.google.com/",
    },
    {
      name: "Vercel",
      description: "Deployment & hosting platform",
      icon: "https://assets.vercel.com/image/upload/front/favicon/vercel/180x180.png",
      link: "https://vercel.com/",
    },
    {
      name: "Postman",
      description: "API development and testing",
      icon: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
      link: "https://www.postman.com/",
    },
    {
      name: "Others",
      description: "Additional tools & technologies",
      icon: "https://cdn-icons-png.flaticon.com/512/2799/2799936.png",
      link: "#",
    },
  ],
};

export default siteConfig;
